import { render, staticRenderFns } from "./PatientPhoto.vue?vue&type=template&id=c87cbc32&scoped=true"
import script from "./PatientPhoto.vue?vue&type=script&lang=js"
export * from "./PatientPhoto.vue?vue&type=script&lang=js"
import style0 from "./PatientPhoto.vue?vue&type=style&index=0&id=c87cbc32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cbc32",
  null
  
)

export default component.exports